import { render, staticRenderFns } from "./SummaryListItem.vue?vue&type=template&id=450ffb44"
import script from "./SummaryListItem.vue?vue&type=script&lang=js"
export * from "./SummaryListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports